import Axios from "axios";
import {
    SET_CUSTOMER_MAP_LIST,
    UNSET_CUSTOMER_MAP_LIST,
  } from "@/store/mutation-types";
import { saveUpdateCustomerMap, getCustomerMapList } from "@/store/api";
// initial state
const state = {
  getCustomerMapList: [],
};

const getters = {
  getCustomerMapList(state) {
    return state.getCustomerMapList;
  },
};
const mutations = {
  [SET_CUSTOMER_MAP_LIST](state, data) {
    state.getCustomerMapList = data;
  },
  [UNSET_CUSTOMER_MAP_LIST](state) {
    state.getCustomerMapList = [];
  },
};

const actions = {
  saveUpdateCustomerMap({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateCustomerMap, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getCustomerMapList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getCustomerMapList, data)
        .then(function (response) {
          commit('SET_CUSTOMER_MAP_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_CUSTOMER_MAP_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
